import { Box, List } from "@mui/material";
import LoadingView from "../../components/LoadingView";
import { useMarcature } from "../../service/marcature";
import ItemMarcatura from "./ItemMarcatura";

const MarcatureOperatore = ({

    idoperatorecantiere = ""

}) => {

  const marcature = useMarcature({
    idoperatorecantiere: idoperatorecantiere,
    idcantiere: null,
    datada: null,
    dataa: null,
  });

  return (
    <Box>
      {marcature.isLoading === true ? (
        <LoadingView />
      ) : (
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
          {marcature.results &&
            marcature.results.map((result, key) => (
              <ItemMarcatura key={key} marcatura={result} />
            ))}
        </List>
      )}
    </Box>
  );
};

export default MarcatureOperatore; 